import {Button, Dialog, OverlayArrow, Popover} from 'react-aria-components'

import AeroplaneSvg from '@/assets/flight/icons/aeroplane.svg?react'
// import DeliveryTruckSvg from '@/assets/food/icons/delivery-truck.svg?react'
import BeakSvg from '@/assets/icons/beak.svg?react'
import LogoutSvg from '@/assets/icons/logout.svg?react'
import AddressSvg from '@/assets/icons/manage-address.svg?react'
import OrderSvg from '@/assets/icons/order.svg?react'
import RewardsSvg from '@/assets/icons/rewards.svg?react'
import UserSvg from '@/assets/icons/user.svg?react'
import LogoutDialog from '@/auth/components/LogoutDialog'
import useIsAuthenticated from '@/auth/hooks/useIsAuthenticated'
import BookmarkLink from '@/layout/BookmarkLink'
import style from '@/layout/NavbarEnd.module.scss'
import {
  AddressesRoute,
  FlightsRoute,
  // FoodOrdersRoute,
  OrdersRoute,
  ProfileRoute,
  RewardsRoute,
  SignInRoute,
} from '@/routeRegistry'

function AuthenticatedMenu({onClick}: {onClick: () => void}) {
  return (
    <>
      <li>
        <Link to={ProfileRoute.fullPath} className={style.UserDropdownItem} onClick={onClick}>
          <UserSvg />
          Profile
        </Link>
      </li>
      <li>
        <Link to={OrdersRoute.fullPath} className={style.UserDropdownItem} onClick={onClick}>
          <OrderSvg />
          Orders
        </Link>
      </li>
      <li>
        <Link to={FlightsRoute.fullPath} className={style.UserDropdownItem} onClick={onClick}>
          <AeroplaneSvg />
          Flights
        </Link>
      </li>
      {/* <li>
        <Link to={FoodOrdersRoute.fullPath} className={style.UserDropdownItem} onClick={onClick}>
          <DeliveryTruckSvg />
          Food Orders
        </Link>
      </li> */}
      <li>
        <Link to={RewardsRoute.fullPath} className={style.UserDropdownItem} onClick={onClick}>
          <RewardsSvg />
          Rewards
        </Link>
      </li>
      <li>
        <Link to={AddressesRoute.fullPath} className={style.UserDropdownItem} onClick={onClick}>
          <AddressSvg />
          Addresses
        </Link>
      </li>
    </>
  )
}
const LogoutButton = memo(function LogoutButton() {
  return (
    <Button className={clsx(style.UserDropdownItem, style.Logout)} aria-haspopup='dialog'>
      <LogoutSvg aria-hidden />
      Logout
    </Button>
  )
})

interface Props {
  isUserDropdownShow: boolean
  setIsUserDropdownShow: (isUserDropdownShow: boolean) => void
}

export default memo(function UserMenuPopover({isUserDropdownShow, setIsUserDropdownShow}: Props) {
  const isAuthenticated = useIsAuthenticated()

  const hideUserDropdown = useCallback(() => {
    setIsUserDropdownShow(false)
  }, [setIsUserDropdownShow])

  return (
    <Popover
      isOpen={isUserDropdownShow}
      onOpenChange={() => {
        setIsUserDropdownShow(false)
      }}
    >
      <OverlayArrow>
        <BeakSvg className={style.Beak} aria-hidden />
      </OverlayArrow>
      <Dialog>
        <ul className={style.UserDropdown}>
          {isAuthenticated && <AuthenticatedMenu onClick={hideUserDropdown} />}
          {!isAuthenticated && (
            <li>
              <Link
                to={SignInRoute.fullPath}
                className={style.UserDropdownItem}
                onClick={hideUserDropdown}
              >
                <UserSvg />
                Login
              </Link>
            </li>
          )}
          <li>
            <BookmarkLink className={style.UserDropdownItem} onClick={hideUserDropdown} />
          </li>
          {isAuthenticated && (
            <li>
              <LogoutDialog onLogout={hideUserDropdown}>
                <LogoutButton />
              </LogoutDialog>
            </li>
          )}
        </ul>
      </Dialog>
    </Popover>
  )
})
